import { render, staticRenderFns } from "./ganyuku.vue?vue&type=template&id=bd2cefb8&scoped=true"
import script from "./ganyuku.vue?vue&type=script&lang=ts"
export * from "./ganyuku.vue?vue&type=script&lang=ts"
import style0 from "./ganyuku.vue?vue&type=style&index=0&id=bd2cefb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2cefb8",
  null
  
)

export default component.exports